import {
  currentReadRights,
  isLoggedIn,
  logout,
} from "@/store/useAuthentification";
import { setSnackBar } from "@/store/useNotificationSnackBar";
import { eTypeSnackBar } from "@/types/ui";
import {
  createRouter,
  createWebHashHistory,
  RouteLocationNormalized,
  RouteRecordRaw,
} from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "root",
    component: () => import("@/views/HomeView.vue"),
    meta: { authorize: [] },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
    meta: { authorize: [] },
  },
  {
    path: "/simulation",
    name: "home",
    component: () => import("@/views/SimulationView.vue"),
    meta: { authorize: [] },
  },
  {
    path: "/mentionslegales",
    name: "mentionslegales",
    component: () => import("@/views/MentionsView.vue"),
    meta: { authorize: [] },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutView.vue"),
    meta: { authorize: [] },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/auth/LoginView.vue"),
    meta: { authorize: ["*"] },
  },
  {
    path: "/profil",
    name: "profil",
    component: () => import("@/views/auth/ProfilView.vue"),
    meta: { authorize: ["*"] },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/search/SearchView.vue"),
    meta: { authorize: ["*"] },
  },
  {
    path: "/map",
    name: "map",
    component: () => import("@/views/map/MapView.vue"),
    meta: { authorize: ["*"] },
  },
  {
    path: "/imports/:id",
    name: "imports1",
    component: () => import("@/views/imports/ImportListView.vue"),
    meta: { authorize: ["ADMIN", "IMPORT_OWN"] },
  },
  {
    path: "/imports",
    name: "imports",
    component: () => import("@/views/imports/ImportListView.vue"),
    meta: { authorize: ["ADMIN", "IMPORT_OWN"] },
  },
  {
    path: "/imports/edit",
    name: "import-edit",
    component: () => import("@/views/imports/ImportStepMainView.vue"),
    meta: { authorize: ["ADMIN", "IMPORT_OWN"] },
  },
  {
    path: "/issues",
    name: "issues",
    component: () => import("@/views/issues/IssuesListView.vue"),
    meta: { authorize: ["*"] },
  },
  {
    path: "/baskets",
    name: "baskets",
    component: () => import("@/views/basket/BasketListView.vue"),
    meta: { authorize: ["*"] },
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("@/views/NoticeView.vue"),
    meta: { authorize: [] },
  },
  {
    path: "/administration",
    name: "administration",
    component: () => import("@/views/administration/IndexView.vue"),
    meta: { authorize: ["ADMIN"] },
    children: [
      {
        path: "dico",
        name: "administration-dico",
        component: () => import("@/views/administration/DicoListView.vue"),
        meta: { authorize: ["ADMIN"] },
      },
      {
        path: "topic",
        name: "administration-topic",
        component: () => import("@/views/administration/TopicListView.vue"),
        meta: { authorize: ["ADMIN"] },
      },
      {
        path: "user",
        name: "administration-user",
        component: () => import("@/views/administration/UserListView.vue"),
        meta: { authorize: ["ADMIN"] },
      },
      {
        path: "site",
        name: "administration-site",
        component: () => import("@/views/administration/SiteListView.vue"),
        meta: { authorize: ["ADMIN"] },
      },
      {
        path: "tool",
        name: "administration-tool",
        component: () => import("@/views/administration/UserListView.vue"),
        meta: { authorize: ["ADMIN"] },
      },
      {
        path: "variable",
        name: "administration-variable",
        component: () => import("@/views/administration/VariableListView.vue"),
        meta: { authorize: ["ADMIN"] },
      },
      {
        path: "externallayer",
        name: "administration-externallayer",
        component: () =>
          import("@/views/administration/ExternalLayerListView.vue"),
        meta: { authorize: ["ADMIN"] },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(
  async (to: RouteLocationNormalized, from: RouteLocationNormalized, next) => {
    const authorize = to.meta.authorize as string[];

    if (authorize == undefined || authorize.length === 0) {
      // Si aucune info,  c'est qu'il n'y a pas de restriction --> On continue!
      next();
    } else {
      if (!isLoggedIn) {
        logout();
        next({ path: "/login" });
      } else {
        // Check session et actualise le tocken
        //const activeSession = await refreshTokenUser();

        //if (!activeSession) {
        //   next({ path: "/login" });
        // } else {
        const userRight = currentReadRights.value.map((value) => value.code);
        const intersection = authorize.filter((x) => userRight.includes(x));
        if (intersection.length > 0 || authorize.includes("*")) {
          next();
        } else {
          setSnackBar("snack-notif.not-authorized", eTypeSnackBar.warning);
          next({ path: "/" });
        }
        // }
      }
    }
  },
);

export default router;
